import { createQueryKeys } from '@lukemorales/query-key-factory';

import { fetchStatsPrivacy } from '../api/statsPrivacy.api';

export const statsPrivacyQueryKeys = createQueryKeys('statsPrivacy', {
  fetchPrivacy: () => ({
    queryFn: () => fetchStatsPrivacy(),
    queryKey: ['self'],
  }),
});
